export default __webpack_public_path__ + "static/media/cyan2.53205047.png";